import { DspReportRequestParameters, PublisherReportRequestParameters, RawReportRequestParameters, ReportControllerApi, ReportRequestParametersObjectObject } from 'src/api/api';
import { BaseApi, configuration } from 'src/api/BaseApi';

export enum ReportType {
    PublisherRevenue = 'PublisherRevenue',
    DspSpent = 'DspSpent',
}

class ReportApi extends BaseApi {
    api: ReportControllerApi;

    constructor() {
        super();
        this.api = new ReportControllerApi(configuration, configuration.basePath, this.customFetch);
    }

    createPublisher(params: PublisherReportRequestParameters) {
        return this.api.createPublisherReport({...params, type: ReportRequestParametersObjectObject.TypeEnum.ByPublisher})
    }
    createPublisherDashboard(params: any) {
        return this.api.createPublisherDashboardReport({...params, 
            // type: ReportRequestParametersObjectObject.TypeEnum.ByPublisher
        })
    }
    getPublisherDomains(params: any) {
        return this.api.getPublisherDomains({...params, type: ReportRequestParametersObjectObject.TypeEnum.ByPublisher})
    }
    getPublisherMobileAppIds(params: any) {
        return this.api.getPublisherMobileAppIds({...params, type: ReportRequestParametersObjectObject.TypeEnum.ByPublisher})
    }
    createDsp(params: DspReportRequestParameters) {
        return this.api.createDspReport({...params, type: ReportRequestParametersObjectObject.TypeEnum.ByDsp})
    }

    get(id: string) {
        return this.api.getReport(id)
    }
    getTransactionStartDate(id: string) {
        return this.api.getTransactionStartDate(id)
    }

    createRaw(params: RawReportRequestParameters) {
        return this.api.createRawReport({...params, type: ReportRequestParametersObjectObject.TypeEnum.Raw})
    }

    info(id: string) {
        return this.api.reportInfo(id)
    }

    getPublisherReportColumns() {
        return this.api.getPublisherReportColumns()
    }

    getDspReportColumns() {
        return this.api.getDspReportColumns()
    }
    
    createTopNPublisherReport(params: any) {
        return this.api.createTopNPublisherReport({...params})
    }

}

const reportApi = new ReportApi()

export default reportApi
